var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contenedor-pagina",style:({ '--color-fondo': _vm.ColorFondo })},[(_vm.EsAfiliado)?_c('HomeAfiliado'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }